import { render, staticRenderFns } from "./cardGalleryBlockCard.vue?vue&type=template&id=49b28488&scoped=true&"
import script from "./cardGalleryBlockCard.vue?vue&type=script&lang=js&"
export * from "./cardGalleryBlockCard.vue?vue&type=script&lang=js&"
import style0 from "./cardGalleryBlockCard.vue?vue&type=style&index=0&id=49b28488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b28488",
  null
  
)

export default component.exports